import { render, staticRenderFns } from "./CriarCartorio.vue?vue&type=template&id=38282013&scoped=true"
import script from "./CriarCartorio.vue?vue&type=script&lang=js"
export * from "./CriarCartorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38282013",
  null
  
)

export default component.exports